import { FeedbackEmptyDataState } from '@hotjar/webapp/features/Activation/EmptyStates';
import type { FeedbackEmptyDataStateProps } from '@hotjar/webapp/features/Activation/EmptyStates/PendingDataState';
import { PausedResponses } from '../../../common/PausedResponses/PausedResponses';
import { useResponsesLimit } from '../../../../hooks/useResponsesLimit';

interface FeedbackEmptyProps extends FeedbackEmptyDataStateProps {
  isEmptyState: boolean;
}

export const FeedbackEmptyState = ({
  isDefaultRange,
  resetFilters,
  changeRange,
  isEmptyState,
}: FeedbackEmptyProps): JSX.Element | null => {
  const result = useResponsesLimit(isEmptyState);

  if (!isEmptyState) return null;

  if (result.hasResponsesAvailable) {
    return (
      <FeedbackEmptyDataState
        isDefaultRange={isDefaultRange}
        resetFilters={resetFilters}
        changeRange={changeRange}
      />
    );
  }

  return <PausedResponses date={result.rolloverDate} />;
};
